import { defineStore } from 'pinia';

export const useFilterStore = defineStore('filter', {
  state: () => ({
    // Stores filters for each module: { member: { search: '', page: 1, ... }, event: { ... } }
    moduleFilters: {},
    currentModuleName: null,
  }),

  actions: {
    /**
     * Update filters for a specific module
     * @param {string} module - The module name (e.g., 'member', 'event')
     * @param {object} filters - The filter data to merge
     */
    updateFilters(module, filters) {
      if (!this.moduleFilters[module]) {
        this.$patch((state) => {
          state.moduleFilters[module] = {};
        });
      }
      
      this.moduleFilters[module] = {
        ...this.moduleFilters[module],
        ...filters
      };
      this.currentModuleName = module;
    },

    /**
     * Get filters for a specific module
     * @param {string} module 
     * @returns {object}
     */
    getFilters(module) {
      return this.moduleFilters[module] || {
        search: '',
        page: 1,
        itemsPerPage: 10,
        selected_flat: '',
        // Add other default filter fields if necessary
      };
    },

    /**
     * Reset filters for a specific module or all modules
     * @param {string|null} module 
     */
    clearFilters(module = null) {
      if (module) {
        delete this.moduleFilters[module];
      } else {
        this.moduleFilters = {};
      }
    },

    /**
     * Logic to handle module changes.
     * If the user moves to a completely different module, we clear the previous module's filters.
     * @param {string} newModule 
     */
    handleModuleChange(newModule) {
      if (this.currentModuleName && this.currentModuleName !== newModule) {
        // User transitioned to a new module, clear the old one's state
        this.clearFilters(this.currentModuleName);
      }
      this.currentModuleName = newModule;
    }
  },

  persist: true, // If using pinia-plugin-persistedstate, but we'll stick to basic for now
});
